import { JSX, useEffect, useRef, useState } from "react";
import { setShowIntroduction } from "../../../app/rootReducer";
import { useAppSelector } from "../../../app/hooks";
import { useDispatch } from "react-redux";
import { useStringTranslation } from "../../hooks/useStringTranslation";

export const Introduction = (): JSX.Element | null => {
    const { t } = useStringTranslation();
    const storyRef = useRef<HTMLDivElement>(null);
    const imageRef = useRef<HTMLDivElement>(null);
    const { showIntroduction } = useAppSelector((state) => state.root);
    const dispatch = useDispatch();

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const storyElement = storyRef.current;
        const imageElement = imageRef.current;
        if (storyElement && imageElement) {
            setTimeout(() => {
                storyElement.style.opacity = "1";
                imageElement.style.opacity = "1";
            }, 100);
        }
    }, [currentSlide, showIntroduction]);

    const slides = [
        {
            image: "/images/slides/slide1.png",
            imageText: t("introduction-slide-one-image-text"),
            title: t("introduction-slide-one-title"),
            subtitle: t("introduction-slide-one-subtitle"),
            description: t("introduction-slide-one-description"),
        },
        {
            image: "/images/slides/slide2.png",
            imageText: t("introduction-slide-two-image-text"),
            title: t("introduction-slide-two-title"),
            subtitle: t("introduction-slide-two-subtitle"),
            description: t("introduction-slide-two-description"),
        },
        {
            image: "/images/slides/slide3.png",
            imageText: t("introduction-slide-three-image-text"),
            title: t("introduction-slide-three-title"),
            subtitle: t("introduction-slide-three-subtitle"),
            description: t("introduction-slide-three-description"),
        },
        {
            image: "/images/slides/slide4.png",
            imageText: t("introduction-slide-four-image-text"),
            title: t("introduction-slide-four-title"),
            subtitle: t("introduction-slide-four-subtitle"),
            description: t("introduction-slide-four-description"),
        },
        {
            image: "/images/slides/slide5.png",
            imageText: t("introduction-slide-five-image-text"),
            title: t("introduction-slide-five-title"),
            subtitle: t("introduction-slide-five-subtitle"),
            description: t("introduction-slide-five-description"),
        },
        // {
        //     image: "/images/slides/slide6.png",
        //     imageText: StringTranslation('introduction-slide-six-image-text', translations),
        //     title: StringTranslation('introduction-slide-six-title', translations),
        //     subtitle: StringTranslation('introduction-slide-six-subtitle', translations),
        //     description: StringTranslation('introduction-slide-six-description', translations),
        // },
        {
            image: "/images/slides/slide7.png",
            imageText: t("introduction-slide-seven-image-text"),
            title: t("introduction-slide-seven-title"),
            subtitle: t("introduction-slide-seven-subtitle"),
            description: t("introduction-slide-seven-description"),
        },
        {
            image: "/images/slides/slide8.png",
            imageText: t("introduction-slide-eight-image-text"),
            title: t("introduction-slide-eight-title"),
            subtitle: t("introduction-slide-eight-subtitle"),
            description: t("introduction-slide-eight-description"),
        },
    ];

    const handleClick = (): void => {
        localStorage.setItem("introductionSlide", "false");
        dispatch(setShowIntroduction(false));
    };

    const handleNext = (): void => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    };

    const handlePrev = (): void => {
        setCurrentSlide(
            (prevSlide) => (prevSlide - 1 + slides.length) % slides.length,
        );
    };

    if (!showIntroduction) return null;

    return (
        <div className="l-dark-overlay">
            <div className="l-dark-overlay__container">
                <section className="c-introduction">
                    <div className="c-introduction__left">
                        <div
                            key={currentSlide}
                            ref={imageRef}
                            className={"c-introduction__image-container"}
                        >
                            <div className={"c-introduction__left__container"}>
                                <img
                                    className="c-introduction__image"
                                    src={slides[currentSlide].image}
                                    alt="Intro"
                                />
                            </div>
                            <div className="c-introduction__image-container__title">
                                <p className="c-introduction__image-container__title__number">
                                    {currentSlide + 1}
                                </p>
                                <p className="c-introduction__image-container__title__text">
                                    {slides[currentSlide].imageText}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="c-introduction__right">
                        <button
                            className="c-introduction__close"
                            onClick={handleClick}
                        >
                            <img src={"/images/cross.svg"} alt="cross" />
                        </button>
                        <div
                            key={currentSlide}
                            ref={storyRef}
                            className="c-introduction__story"
                        >
                            <h2 className="c-introduction__story__title">
                                {slides[currentSlide].title}
                            </h2>
                            <p className="c-introduction__story__subtitle">
                                {slides[currentSlide].subtitle}
                            </p>
                            <p className="c-introduction__story__text">
                                {slides[currentSlide].description}
                            </p>
                        </div>
                        <div className="c-introduction__buttons">
                            <div className="c-introduction__arrows">
                                <button
                                    className="c-introduction__arrow c-introduction__arrow--left"
                                    onClick={handlePrev}
                                >
                                    <img
                                        src="/images/arrow-down.svg"
                                        alt="arrow-left"
                                    />
                                </button>
                                <button
                                    className="c-introduction__arrow c-introduction__arrow--right"
                                    onClick={handleNext}
                                >
                                    <img
                                        src="/images/arrow-down.svg"
                                        alt="arrow-right"
                                    />
                                </button>
                            </div>
                            <button
                                className="c-introduction__button c-introduction__button--skip-part"
                                onClick={handleClick}
                            >
                                {t("introduction-skip-button")}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
